module.exports = __webpack_public_path__ + "img/Res-Icon-2.998361c.png";